// با 9 یوز افکت که درست کار با تغییرات محصولات در لاگ می کنه
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import GetPrice from "../Functions/GetPrice";
import {
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  capitalizeFirstLetters,
  capitalizeWordsText,
} from "../Functions/TextTransform";
import OverlayContainer from "../Components/OverlayContainer";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import NumberToPersianWord from "number_to_persian_word";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import InnerImageZoom from "react-inner-image-zoom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useMediaQuery } from "react-responsive";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import RenderSideCart from "../Components/RenderSideCart";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import StaticMeasureHelps from "../Static Files/StaticMeasureHelps";
import { ShowLogin2Modal } from "../Actions/types";
import ProductCard from "../Components/ProductCard";
import { baseURLCats, baseURLCatProduct, baseURLAddProduct, baseURLSaveProduct, baseURLFreeShipping, baseURLGetFavorites, baseURLDeleteFavorite, imgUrl } from "../config/api";

function ReadyMadeTowel() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const { productID } = useParams();
  const { designID } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLoggedIn, sideCartPrice, SideDiscountedPrice } = useSelector((state) => state.auth);
  const [completePageState, setCompletePageState] = useState(searchParams.get("C"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [modals, setModals] = useState({});
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [cartCount, setCartCount] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const splideRef = useRef(null);
  const [catObject, setCatObject] = useState({});
  const [productAwaitingLogin, setProductAwaitingLogin] = useState([]);
  const [catProducts, setCatProducts] = useState([]);
  const [catAllProducts, setCatAllProducts] = useState([]);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredProducts2, setFilteredProducts2] = useState([]);
  const [userFavorites, setUserFavorites] = useState([]);
  const [designProducts, setDesignProducts] = useState({});
  const [activeProduct, setActiveProduct] = useState({});
  const [splidesList, setSplidesList] = useState([]);
  const [slidesList, setSlidesList] = useState([]);
  const [colorsList, setColorsList] = useState([]);
  const [sizesList, setSizesList] = useState([]);
  const [widthList, setWidthList] = useState([]);
  const [lengthList, setLengthList] = useState([]);
  const [controlsList, setControlsList] = useState([]);
  const [liningsList, setLiningsList] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [isPageComplete, setIsPageComplete] = useState(completePageState === "1");
  const [isColorSelected, setIsColorSelected] = useState(true);
  const [isSizeSelected, setIsSizeSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] === "Ready-Made-Shade"
  );
  const [isWidthSelected, setIsWidthSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "Ready-Made-Shade"
  );
  const [isLengthSelected, setIsLengthSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "Ready-Made-Shade"
  );
  const [isControlSelected, setIsControlSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "Ready-Made-Shade"
  );
  const [isLiningSelected, setIsLiningSelected] = useState(completePageState === "1");
  const [colorError, setColorError] = useState(false);
  const [qty, setQty] = useState(0);
  const [addingLoading, setAddingLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [removingLoading, setRemovingLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectionKey, setSelectionKey] = useState(0);
  const prevProductIdRef = useRef(null);

  const resetProductSelections = () => {
    setProducts([]);
    setTotalQty(0);
    setTotalPriceSum(0);
    setSelectionKey((key) => key + 1);
  };

  const getCatProducts = () => {
    if (searchParams.get("Product") && searchParams.get("Product") !== "") {
      axios
        .get(baseURLCats, {
          params: {
            pageName: catID,
          },
        })
        .then((response) => {
          setCatObject(response.data || {});
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
      axios
        .get(baseURLCatProduct, {
          params: {
            groupId: productID,
            designs: designID,
          },
        })
        .then((response) => {
          if (response.data && response.data["Products"].length) {
            setCatProducts(response.data["Products"]);
            setCatAllProducts(response.data["Products"]);
          } else {
            setCatProducts({});
            setDesignProducts({});
            navigate("/" + pageLanguage);
          }
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
    } else {
      navigate("/" + pageLanguage);
    }
  };
console.log(`totalQty`, totalQty);
  function getFavorites() {
    axios
      .get(baseURLGetFavorites, {
        headers: authHeader(),
      })
      .then((response) => {
        if (isLoggedIn && !response.data?.length && productAwaitingLogin.length) {
          saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
          setProductAwaitingLogin([]);
        }
        setUserFavorites(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getFavorites();
            } else {
              // navigate("/" + pageLanguage);
            }
          });
        } else {
          setUserFavorites([]);
        }
      });
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function getActiveColorProducts() {
    let tempActiveProduct =
      catProducts.find((obj) => obj["ProductId"] === searchParams.get("Product")) || {};

    if (Object.keys(tempActiveProduct).length === 0) {
      navigate("/" + pageLanguage);
    } else {
      let temp = {};
      let promiseArr = [];
      catProducts.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          if (
            temp[obj["ColorId"]] === "" ||
            temp[obj["ColorId"]] === undefined ||
            temp[obj["ColorId"]] === null ||
            temp[obj["ColorId"]].length === 0
          ) {
            temp[obj["ColorId"]] = [];
          }
          temp[obj["ColorId"]].push(obj);
          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setDesignProducts(temp);

        setActiveProduct(tempActiveProduct);
      });
    }
  }

  function renderPageContent() {
    if (Object.keys(designProducts).length) {
      let temp = [];
      let temp2 = {};
      let temp3 = [];
      let temp4 = [];
      let temp5 = {};
      let temp6 = {};
      let temp7 = {};
      let temp8 = {};
      let promiseArr = [];
      Object.keys(designProducts).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let ProductId = designProducts[key][0]["ProductId"];
          let SewingModelId = designProducts[key][0]["SewingModelId"];
          let ColorEnName = CapitalizeAllWords(designProducts[key][0]["ColorEnName"]);
          let ColorName = convertToPersian(designProducts[key][0]["ColorName"]);
          let ColorPhotoPath =
            designProducts[key][0]["Photos"].find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl ||
            "";
          let isActiveColor = designProducts[key]
            .map(function(obj) {
              return obj["ProductId"];
            })
            .filter((n) => n)
            .includes(searchParams.get("Product"));
          temp.push(
            <li
              key={"color" + ProductId + index}
              className={`rmd_info_colors_list_item Accessories_List_item_colors_list_item ${
                isColorSelected && isActiveColor ? "colorSelected" : ""
              }`}
              onClick={() => {
                if (!isColorSelected) {
                  setIsColorSelected(true);
                }
                setSearchParams("?Product=" + ProductId);
                resetProductSelections();
              }}
            >
              <OverlayContainer
                classNames="Accessories_List_item_color"
                placement="middle"
                children={
                  <div
                    className="Accessories_List_item_colors_list_item_overlay"
                    style={{
                      background:
                        `transparent url(${imgUrl(ColorPhotoPath.trim())}) no-repeat`,
                    }}
                  />
                }
                component={
                  <div className="Accessories_List_item_color_container">
                    <p className="Accessories_List_item_color_text">
                      {pageLanguage === "en" ? ColorEnName : ColorName}
                    </p>
                  </div>
                }
              />
            </li>
          );

          let promiseArr2 = [];
          designProducts[key].forEach((obj, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              let isActiveProduct = obj["ProductId"] === searchParams.get("Product");
              let sizeText = obj["ProductSizeEnName"];
              let sizeTextFa = obj["ProductSizeName"];
              if (temp2[sizeText] === undefined || isActiveProduct) {
                temp2[sizeText] = (
                  <li
                    key={"size" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isSizeSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isSizeSelected) {
                          setIsSizeSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {pageLanguage === "fa" ? sizeTextFa : sizeText}
                    </button>
                  </li>
                );
              }
              let isActiveLining = obj["ProductId"] === searchParams.get("Product");
              let liningText = obj["HasLining"] ? "standard" : "noLining";
              if (temp5[liningText] === undefined || isActiveLining) {
                temp5[liningText] = (
                  <li
                    key={"lining" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isLiningSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isLiningSelected) {
                          setIsLiningSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {obj["HasLining"] ? t("Standard Lining") : t("Unlined")}
                    </button>
                  </li>
                );
              }

              let widthText = obj["Width"];

              if (temp6[widthText] === undefined || isActiveProduct) {
                temp6[widthText] = (
                  <li
                    key={"Width" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isWidthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isWidthSelected) {
                          setIsWidthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(widthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }

              let lengthText = obj["Length"];
              if (temp7[lengthText] === undefined || isActiveProduct) {
                temp7[lengthText] = (
                  <li
                    key={"Length" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isLengthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isLengthSelected) {
                          setIsLengthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(lengthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }
              let controlText = obj["ControlPosition"] ? "Right" : "Left";
              let controlImg = undefined;
              if (temp8[controlText] === undefined || isActiveColor) {
                if (SewingModelId === "0303") {
                  controlImg =
                    controlText === "Right"
                      ? require("../Images/drapery/zebra/position_right.svg").default
                      : require("../Images/drapery/zebra/position_left.svg").default;
                } else if (SewingModelId === "0324") {
                  controlImg =
                    controlText === "Right"
                      ? require("../Images/drapery/roller/position_right.svg").default
                      : require("../Images/drapery/roller/position_left.svg").default;
                }
                temp8[controlText] = (
                  <li
                    key={"ControlPosition" + ProductId + i}
                    className={`rmd_info_cp_list_item img_box ${
                      isActiveColor
                        ? isControlSelected && isActiveProduct
                          ? "colorSelected"
                          : ""
                        : "crossed"
                    }`}
                    onClick={() => {
                      if (!isControlSelected) {
                        setIsControlSelected(true);
                      }
                      setSearchParams("?Product=" + obj["ProductId"]);
                    }}
                  >
                    {SewingModelId === "0303" && (
                      <div className="rmd_info_cp_list_item_img_container">
                        <img src={controlImg} className="img-fluid" alt="" />
                        <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                      </div>
                    )}
                    {SewingModelId === "0324" && (
                      <div className="rmd_info_cp_list_item_container">
                        <div className="rmd_info_cp_list_item_title_container">
                          <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                        </div>
                        <div className="rmd_info_cp_list_item_img_container">
                          <img src={controlImg} className="img-fluid" alt="" />
                        </div>
                      </div>
                    )}
                    {SewingModelId === "0325" && (
                      <div className="rmd_info_cp_list_item_container">
                        <div className="rmd_info_cp_list_item_img_container">
                          <img src={controlImg} className="img-fluid" alt="" />
                        </div>
                        <div className="rmd_info_cp_list_item_title_container">
                          <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                        </div>
                      </div>
                    )}
                  </li>
                );
              }

              let promiseArr3 = [];
              if (isActiveProduct) {
                let tempPhotosArr = [
                  obj["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl,
                ];
                tempPhotosArr.push(
                  ...obj["Photos"]
                    .map(function(object) {
                      if (object["PhotoTypeId"] !== 4702 && object["PhotoTypeId"] !== 4709) {
                        return object["PhotoUrl"];
                      } else {
                        return undefined;
                      }
                    })
                    .filter((n) => n)
                );
                tempPhotosArr.forEach((el, j) => {
                  promiseArr3[j] = new Promise((resolve, reject) => {
                    temp3.push(
                      <SplideSlide key={"splide" + ProductId + j} onClick={() => setActiveIndex(j)}>
                        <img
                          className="img-fluid"
                          src={imgUrl(el)}
                          alt={"Image" + j}
                        />
                      </SplideSlide>
                    );
                    temp4.push(
                      <Carousel.Item key={"slide" + obj["ProductId"] + j} className="unselectable">
                        <InnerImageZoom
                          src={imgUrl(el)}
                          zoomSrc={imgUrl(el)}
                          zoomType="none"
                          hideHint={true}
                        />
                      </Carousel.Item>
                    );
                    resolve();
                  });
                });
              }
              Promise.all(promiseArr3).then(() => {
                resolve();
              });
            });
          });
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setColorsList(temp);
        setSizesList(
          Object.keys(temp2)
            .sort()
            .map((key) => temp2[key])
        );
        setLiningsList(Object.values(temp5));
        setWidthList(Object.values(temp6));
        setLengthList(Object.values(temp7));
        if (Object.keys(temp8).length > 1) {
          setControlsList([temp8["Left"], temp8["Right"]]);
        } else {
          setControlsList(Object.values(temp8));
        }
        setSplidesList(temp3);
        setSlidesList(temp4);
      });
    } else {
      setColorsList([]);
      setSizesList([]);
      setLiningsList([]);
      setWidthList([]);
      setLengthList([]);
      setSlidesList([]);
      setSplidesList([]);
    }
  }

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_desc_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_desc_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_accordion_btn_arrow_up img-fluid"
                : "product_accordion_btn_arrow_down img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  function addProduct(productsArray) {
    const productsToAdd = productsArray.filter((product) => product.qty > 0);
    if (productsToAdd.length === 0) {
      setAddingLoading(false);
      return;
    }

    resetProductSelections();

    if (isLoggedIn) {
      productsToAdd.forEach((product) => {
        console.log(`product.qty`, product.qty);
        axios
          .post(
            baseURLAddProduct,
            {},
            {
              headers: authHeader(),
              params: {
                productId: product["ProductId"],
                color: product["Color"], // Assuming color is stored in product["Color"]
                width: product["Width"], // Assuming width is stored in product["Width"]
                count: product.qty,
              },
            }
          )
          .then((response) => {
            setSideCartObjects(response.data || {});
            setCartCount(response.data?.CartDetails?.length || 0);
            modalHandleShow("cart_modal");
            setAddingLoading(false);
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  addProduct(productsToAdd);
                } else {
                  addProduct(productsToAdd);
                }
              });
            } else {
              setAddingLoading(false);
            }
          });
      });
    } else {
      productsToAdd.forEach((product) => {
        const productQty = product["qty"] || parseInt(qty);
        product["Count"] = productQty;
        product["PhotoUrl"] =
          product["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl || "";

        let customPageCart = {};
        console.log("productQty", productQty);

        // اگر سبد خرید در localStorage وجود ندارد
        if (localStorage.getItem("cart") === null) {
          let newCartObj = {};
          let newCartArr = [];
          newCartArr[0] = product;
          newCartObj["drapery"] = [];
          newCartObj["drapery"] = newCartArr;
          newCartObj["swatches"] = [];
          localStorage.setItem("cart", JSON.stringify(newCartObj));
          customPageCart = newCartObj;
        } else {
          // سبد خرید را از localStorage دریافت کنید
          let cartObj = JSON.parse(localStorage.getItem("cart"));
          console.log(`cartObj`, cartObj);
          // اگر سبد خرید خالی است یا محصولات در آن وجود ندارد
          if (!cartObj["drapery"] || cartObj["drapery"].length === 0) {
            console.log("من برای قسمت خالی سبد خرید هستم و محصول درون من نیست");

            let newCartArr = [];
            newCartArr[0] = product;
            cartObj["drapery"] = newCartArr;
            localStorage.setItem("cart", JSON.stringify(cartObj));
            customPageCart = cartObj;
          } else {
            // بررسی کنید که آیا محصول قبلاً در سبد خرید وجود دارد
            let tempProjectContainerIndex = cartObj["drapery"].findIndex(
              (obj) => obj["ProductId"] === product["ProductId"]
            );

            // اگر محصول در سبد خرید وجود دارد
            if (tempProjectContainerIndex !== -1) {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] += parseInt(productQty);
              cartObj["drapery"][tempProjectContainerIndex]["qty"] =
                cartObj["drapery"][tempProjectContainerIndex]["Count"];

              // جمع کردن قیمت کل
              cartObj["drapery"][tempProjectContainerIndex]["TotalPrice"] +=
                product["TotalPrice"] * parseInt(qty);

              // مقدار qty سایر محصولات را به اندازه ۱ کاهش دهید
              cartObj["drapery"].forEach((obj, index) => {
                if (index !== tempProjectContainerIndex && obj["qty"] > 0) {
                  obj["qty"] -= 1; // کاهش مقدار qty به اندازه ۱
                }
              });
              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];

              cartObj["drapery"].push(updatedProduct);
              localStorage.setItem("cart", JSON.stringify(cartObj));
              customPageCart = cartObj;
            } else {
              // اگر محصول در سبد خرید وجود ندارد
              cartObj["drapery"].push(product);
              localStorage.setItem("cart", JSON.stringify(cartObj));
              customPageCart = cartObj;
            }
          }
        }

        // به‌روزرسانی سبد خرید در UI
        setSideCartObjects(customPageCart);

        // محاسبه تعداد کل آیتم‌ها در سبد خرید
        let cartCount = customPageCart["drapery"]?.length || 0;
        // cartCount += customPageCart["drapery"]?.length || 0;
        setCartCount(parseInt(cartCount) || 0);

        // نمایش مدال سبد خرید
        modalHandleShow("cart_modal");

        // غیر فعال کردن حالت لودینگ افزودن محصول
        setAddingLoading(false);
      });
    }
  }

  function saveProduct(product, isCompleted, forceAdd) {
    if (isLoggedIn) {
      let tempIndex = userFavorites.findIndex(
        (obj) => obj.ProductId === activeProduct["ProductId"] && obj.IsComplete === isCompleted
      );
      if (!forceAdd && tempIndex > -1) {
        setRemovingLoading(true);
        removeProject(userFavorites[tempIndex]["FavoriteProductId"]);
      } else {
        setSavingLoading(true);
        axios
          .get(baseURLSaveProduct, {
            headers: authHeader(),
            params: {
              id: product["ProductId"],
              pageName: catID,
              isComplete: isCompleted,
            },
          })
          .then((response) => {
            setUserFavorites(response.data || []);
            setSavingLoading(false);
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  saveProduct(product, isCompleted);
                } else {
                  saveProduct(product, isCompleted);
                }
              });
            } else {
              setSavingLoading(false);
            }
          });
      }
    } else {
      setProductAwaitingLogin([product, isCompleted]);
      dispatch({
        type: ShowLogin2Modal,
      });
    }
  }

  function removeProject(id) {
    axios
      .delete(baseURLDeleteFavorite, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        // getFavorites();
        setUserFavorites(response.data || []);
        setRemovingLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              removeProject(id);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setRemovingLoading(false);
        }
      });
  }

  const handleLogChange = (productId, qty, totalPrice, updatedProduct, productItem) => {
    let updatedProducts = products.map((product) => {
      if (product.ProductId === productId) {
        return { ...updatedProduct, qty, totalPrice };
      }
      return product;
    });
console.log(`updatedProducts`, updatedProducts);
    const productExists = updatedProducts.some((product) => product.ProductId === productId);
    if (!productExists && productItem) {
      updatedProducts.push({ ...productItem, qty, totalPrice });
    }

    const uniqueProducts = updatedProducts.reduce((acc, current) => {
      acc[current.ProductId] = current;
      return acc;
    }, {});

    if (productItem && uniqueProducts[productItem.ProductId]) {
      uniqueProducts[productItem.ProductId] = {
        ...productItem,
        qty,
        totalPrice,
      };
    }

    const finalProducts = Object.values(uniqueProducts);

    const totalPriceSum = finalProducts
      .filter((product) => product.qty > 0)
      .reduce((sum, product) => sum + (product.totalPrice || 0), 0);
console.log(`finalProducts`, finalProducts);
    const totalQty = finalProducts.reduce((sum, product) => sum + (product.qty || 0), 0);
    setTotalQty(totalQty);
    setTotalPriceSum(totalPriceSum);
    setProducts(finalProducts);
  };

  const isEnglish = i18n.language === "en";

  const formatPrice = (price) => {
    if (isEnglish) {
      const formattedPrice = new Intl.NumberFormat("en").format(price);
      return `${formattedPrice} Tomans`;
    } else {
      const formattedPrice = new Intl.NumberFormat("fa-IR").format(price);
      return `${formattedPrice} تومان`;
    }
  };

  useEffect(() => {
    renderPageContent();
  }, [designProducts]);

  useEffect(() => {
    if (catProducts.length) {
      getActiveColorProducts();
    }
    if (isColorSelected) {
      setColorError(false);
    }

    if (
      !(
        !(isColorSelected || colorsList.length === 1) ||
        !(isSizeSelected || sizesList.length === 1) ||
        !(isWidthSelected || widthList.length === 1) ||
        !(isLengthSelected || lengthList.length === 1) ||
        !(isControlSelected || controlsList.length === 1) ||
        !(isLiningSelected || liningsList.length === 1)
      )
    ) {
      setIsPageComplete(true);
    } else {
      setIsPageComplete(false);
    }
  }, [
    catProducts,
    searchParams.get("Product"),
    isColorSelected,
    isSizeSelected,
    isWidthSelected,
    isLengthSelected,
    isLiningSelected,
    isControlSelected,
  ]);

  useEffect(() => {
    if (slidesList.length) {
      setActiveIndex(0);
    }
  }, [slidesList]);

  useEffect(() => {
    if (isLoggedIn && userFavorites.length && productAwaitingLogin.length) {
      saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
      setProductAwaitingLogin([]);
    }
  }, [userFavorites]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current.go(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    if (pageLanguage !== "") {
      getCatProducts();
      window.scrollTo(0, 0);
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      getFavorites();
    } else {
      setUserFavorites([]);
    }
  }, [location.pathname, isLoggedIn]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const productIdFromUrl = searchParams.get("Product");
    if (productIdFromUrl) {
      if (productIdFromUrl !== prevProductIdRef.current) {
        resetProductSelections();
        prevProductIdRef.current = productIdFromUrl;
      }
      setCurrentProductId(productIdFromUrl);
      const foundProduct = catAllProducts.find((product) => product.ProductId === productIdFromUrl);

      if (foundProduct) {
        const filtered = catAllProducts.filter(
          (product) => product.ColorId === foundProduct.ColorId
        );
        const filtered2 = catAllProducts.filter(
          (product) => product.ProductSizeNameId === foundProduct.ProductSizeNameId
        );

        setFilteredProducts(filtered);
        setFilteredProducts2(filtered2);
      }
    }
  }, [location, catAllProducts]);
  const sortedfilteredProducts = filteredProducts.sort((a, b) => {
    if (b.Width !== a.Width) {
      return b.Width - a.Width;
    }
    return b.Length - a.Length;
  });

  let minPrice = Infinity;
  let maxPrice = -Infinity;
  let minDisPrice = Infinity;
  let maxDisPrice = -Infinity;
  catAllProducts.forEach((product) => {
    minPrice = Math.min(minPrice, product.Price);
    maxPrice = Math.max(maxPrice, product.Price);
    minDisPrice = Math.min(minDisPrice, product.DiscountedPrice);
    maxDisPrice = Math.max(maxDisPrice, product.DiscountedPrice);
  });

  useEffect(() => {
    axios
    .get(baseURLFreeShipping)
    .then((response) => {
      setFreeShipPrice(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);
  
  useEffect(() => {
    if (sideCartObjects.drapery) {
      setCartCount(sideCartObjects.drapery?.length || 0);
    }
  }, [sideCartObjects]);

  return (
    <div
      className={
        `Product_Item_page_container Ready_made_drapery_page_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }` + ` ${location.pathname.split("/")[2]}`
      }
    >
      <div className="breadcrumb_container dir_ltr">
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{ to: "/" + pageLanguage, className: "breadcrumb_item" }}
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{
              to: "/" + pageLanguage + "/" + location.pathname.split("/")[2] + "/" + catID,
              className: "breadcrumb_item",
              preventScrollReset: true,
            }}
          >
            {CapitalizeAllWords(catObject["EnTitle"])}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="rmd_product_area_container">
        <div className="rmd_title_mob_container mobile_only">
          <h1 className="rmd_title_mob">
            {pageLanguage === "fa" ? activeProduct["ProductName"] : activeProduct["ProductENName"]}{" "}
            {pageLanguage === "fa"
              ? activeProduct["SewingModelName"]
              : activeProduct["SewingModelEnName"]}
          </h1>
          <h2 className="rmd_price_mob">
            {activeProduct["Price"] > 0 &&
              GetPrice(activeProduct["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
          </h2>
        </div>
        <div className="rmd_left_side">
          <div className="rmd_sticky">
            <div className="rmd_vertical_carousel">
              <Splide
                ref={splideRef}
                options={{
                  height: "44rem",
                  width: "8rem",
                  rewind: false,
                  rewindByDrag: false,
                  direction: "ttb",
                  gap: "1.5rem",
                  type: "slide",
                  perPage: 5,
                  perMove: 1,
                  arrows: false,
                  pagination: false,
                  wheel: false,
                  updateOnMove: false,
                  focus: 0,
                }}
                aria-label="My Favorite Images"
              >
                {splidesList}
              </Splide>
            </div>
            <div className="rmd_images_container mobile_only">
              {!!slidesList.length && (
                <Carousel
                  variant="dark"
                  interval={null}
                  activeIndex={activeIndex}
                  controls={false}
                  touch={true}
                  onSelect={(eventKey) => setActiveIndex(eventKey)}
                >
                  {slidesList}
                </Carousel>
              )}
            </div>
            <div className="rmd_images_container desktop_only">
              <Carousel
                variant="dark"
                interval={null}
                activeIndex={activeIndex}
                controls={false}
                touch={true}
              >
                {slidesList}
              </Carousel>
            </div>
          </div>
        </div>
        <div className="rmd_right_side">
          <div className="rmd_info_container">
            <div className="rmd_info_title_container desktop_only">
              <h1 className="rmd_info_title title-rods">
                <p>
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}
                </p>
              </h1>
            </div>
            <div className="rmd_info_price_container desktop_only">
              <div
                className="rmd_info_price"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <span style={minPrice === minDisPrice ? {} : { textDecoration: "line-through" }}>
                  {minPrice !== Infinity &&
                    maxPrice !== -Infinity &&
                    (minPrice === maxPrice
                      ? GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : pageLanguage === "fa"
                      ? GetPrice(maxPrice, pageLanguage, t(""), isTabletOrMobile) +
                        " - " +
                        GetPrice(minPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : GetPrice(minPrice, pageLanguage, t(""), isTabletOrMobile) +
                        " - " +
                        GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile))}
                </span>
                {minPrice !== minDisPrice && (
                  <span style={{ color: "#ca6667" }}>
                    {minDisPrice !== Infinity &&
                      maxDisPrice !== -Infinity &&
                      (minDisPrice === maxDisPrice
                        ? GetPrice(maxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                        : pageLanguage === "fa"
                        ? GetPrice(
                            maxDisPrice,

                            pageLanguage,
                            t(""),
                            isTabletOrMobile
                          ) +
                          " - " +
                          GetPrice(minDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                        : GetPrice(minDisPrice, pageLanguage, t(""), isTabletOrMobile) +
                          " - " +
                          GetPrice(maxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile))}
                  </span>
                )}

                {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                  <div className="products_list_item_body_desc_more_desc">
                    {i18n.language === "en" ? (
                      <>
                        {activeProduct["DiscountEnName"]}: {activeProduct["DiscountPercent"]}% off
                      </>
                    ) : (
                      <>
                        {activeProduct["DiscountName"]} :
                        {new Intl.NumberFormat("fa-IR").format(activeProduct["DiscountPercent"])} %
                        تخفیف
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="rmd_info_colors_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("Color: ")}</h2>
                {colorError && (
                  <h3 className="rmd_info_little_title error_text">{t("Select a color")}</h3>
                )}
                <h3 className="rmd_info_little_title">
                  {isColorSelected || colorsList.length === 1
                    ? pageLanguage === "fa"
                      ? activeProduct["ColorName"]
                      : capitalizeFirstLetters(activeProduct["ColorEnName"])
                    : ""}
                </h3>
              </div>
              <ul className={colorsList.length > 1 ? "rmd_info_colors_list" : "noDisplay"}>
                {colorsList}
              </ul>
            </div>

            <p className="product-title">{t("Choose Items")}</p>
            {sortedfilteredProducts.map((product) => {
              const title =
                i18n.language === "fa"
                  ? product.ProductSizeName
                  : capitalizeWordsText(product.ProductSizeEnName);

              const colorName = i18n.language === "fa" ? product.ColorName : product.ColorEnName;

              const mainPhoto = product.Photos.find((photo) => photo.PhotoOrder === 0)?.PhotoUrl;

              return (
                <ProductCard
                  key={`${product.ProductId}-${selectionKey}`}
                  product={product}
                  productId={product.ProductId}
                  title={title}
                  price={product.Price}
                  DiscountedPrice={product.DiscountedPrice}
                  image={mainPhoto}
                  initialColor={colorName}
                  colors={filteredProducts2}
                  onQtyChange={handleLogChange}
                />
              );
            })}
            <p>
              {t("Your Total Price:")} {formatPrice(totalPriceSum)}
            </p>
            <div className="rmd_info_btn_container bag_buttons_section_container">
              <button
                className="btn add_to_cart"
                onClick={() => {
                  if (totalQty === 0) return;
                  setAddingLoading(true);
                  addProduct(products.filter((product) => product.qty > 0));
                }}
                disabled={addingLoading || savingLoading || removingLoading}
              >
                {addingLoading
                  ? t("ADDING...")
                  : `${t("ADD")} ${
                      totalQty > 0
                        ? `${new Intl.NumberFormat(
                            i18n.language === "en" ? "en-US" : "fa-IR"
                          ).format(totalQty)} ${t("ITEMS")}`
                        : ""
                    } ${t("TO BAG")}`}
              </button>

              <button
                className="save_to_acc white_btn btn"
                onClick={() => {
                  if (isPageComplete) {
                    saveProduct(activeProduct, true);
                  } else {
                    saveProduct(activeProduct, false);
                  }
                }}
                disabled={addingLoading || savingLoading || removingLoading}
              >
                <img
                  src={
                    userFavorites.findIndex(
                      (obj) =>
                        obj.ProductId === activeProduct["ProductId"] &&
                        obj.IsComplete === isPageComplete
                    ) > -1
                      ? require("../Images/public/favorite_filled.png")
                      : require("../Images/public/favorite.png")
                  }
                  className="img-fluid"
                  alt=""
                />
                {savingLoading
                  ? t("SAVING...")
                  : removingLoading
                  ? t("REMOVING...")
                  : t("product_Save_To_wishlist")}
              </button>
            </div>
            <div className="rmd_info_desc_container">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <ContextAwareToggleFilters
                    eventKey="0"
                    textOnHide={t("Product Description")}
                    textOnShow={t("Product Description")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      {pageLanguage === "en" ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: activeProduct["DescriptionEn"],
                          }}
                        />
                      ) : (
                        <p>{convertToPersian(activeProduct["Description"])}</p>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Dimensions")}
                    textOnShow={t("Dimensions")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      {pageLanguage === "en" ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: activeProduct["DimensionEn"],
                          }}
                        />
                      ) : (
                        <p>{convertToPersian(activeProduct["Dimension"])}</p>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <ContextAwareToggleFilters
                    eventKey="2"
                    textOnHide={t("Materials & Care")}
                    textOnShow={t("Materials & Care")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["MatrialCareEn"]
                          : convertToPersian(activeProduct["MatrialCare"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <ContextAwareToggleFilters
                    eventKey="3"
                    textOnHide={t("Shipping & Returns")}
                    textOnShow={t("Shipping & Returns")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["ShippingReturnEn"]
                          : convertToPersian(activeProduct["ShippingReturn"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
        }}
        id="cart_modal"
      >
        <div className="custom_cart_header_desc">{`${
          freeShipPrice - sideCartPrice > 0
            ? `${t("cart_agree_free_ship1")}${
                pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(
                      `${GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}`
                    )
                  : GetPrice(
                      freeShipPrice - sideCartPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )
              }${t("cart_agree_free_ship2")}`
            : `${t("cart_agree_free_ship")}`
        }`}</div>
        <Modal.Header>
          <span className="custom_cart_title">
            {t("My Bag")}{" "}
            <h3>
              (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                : cartCount}
              )
            </h3>
          </span>

          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              sessionStorage.clear();
              resetProductSelections();
              // navigate("/" + pageLanguage);
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout">
            <div className="checkout_button_section small_checkout_button_section">
              <span className="checkout_payment_price_detail payment_price_detail">
                <h3>{t("SUBTOTAL")}</h3>
                <h4>
                  {isLoggedIn
                    ? GetPrice(sideCartPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                    : GetPrice(SideDiscountedPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                </h4>
              </span>
              <Link className="basket_checkout btn" to={"/" + pageLanguage + "/Basket"}>
                {t("CHECKOUT")}
              </Link>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal scroll_on ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
        onHide={() => modalHandleClose("measurementsHelp")}
        scrollable={true}
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <StaticMeasureHelps SewingModelId={activeProduct["SewingModelId"]} />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("measurementsHelp")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="add_to_project_container">
            <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR FAVORITES")}</h2>
            <Link className="add_to_project_btn btn" to={"/" + pageLanguage + "/Account/Favorites"}>
              {t("VIEW FAVORITES")}
            </Link>
            <button
              className="continue_shopping_btn"
              onClick={() => {
                modalHandleClose("add_to_project_modal");
              }}
            >
              {t("CONTINUE SHOPPING")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ReadyMadeTowel;


